import Verified from '@mui/icons-material/Verified'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Stack from '@mui/material/Stack'
import useMediaQuery from '@mui/material/useMediaQuery'
import HgfButton from '~/components/home/helmholtz/ui/HgfButton'
import {SoftwareEvaluationPoFTopicDropdown} from '~/components/software/indicator/SoftwareEvaluationPoFTopic'
import {useSoftwareIndicatorConfiguration} from '~/components/software/indicator/useSoftwareIndicatorConfiguration'
import {useSoftwareQualityOverviewContext} from './SoftwareQualityOverviewContext'
import Chip from '@mui/material/Chip'


export default function AssociatedPoFTopicsDialog({open, onClose, year}: {open: boolean, onClose: () => void, year: string}) {
  const smallScreen = useMediaQuery('(max-width:600px)')
  const {pofTopics} = useSoftwareIndicatorConfiguration(year)
  const organisationCtx = useSoftwareQualityOverviewContext()

  const updateTopics = (topic_ids: string[]) => {
    const associatedIds = new Set(organisationCtx.associatedPofTopics.map(t => t.id))
    topic_ids.forEach(topic => {
      if (associatedIds.has(topic)) {
        associatedIds.delete(topic)
      } else {
        organisationCtx.savePoFTopicForOrganisation(topic)
      }
    })
    associatedIds.forEach(topic => topic ? organisationCtx.deletePoFTopicForOrganisation(topic) : null)
  }

  return (
    <Dialog
      fullScreen={smallScreen}
      open={open}
      onClose={onClose}
      slotProps={{
        paper: {
          sx: {
            minWidth: '70vw',
            minHeight: '40vh',
            borderRadius: '4px'
          }
        }
      }}
    >
      <DialogTitle sx={{
        fontSize: '1.5rem',
        borderBottom: '1px solid',
        borderColor: 'divider',
        color: 'primary.main',
        fontWeight: 500
      }}>
        <Verified/> Associated PoF Topics
      </DialogTitle>
      <DialogContent sx={{
        width: '100%',
        padding: '2rem 1.5rem 2.5rem'
      }}>
        <Stack direction='column' className='h-full justify-center gap-4 py-4'>
          Select PoF topics that are relevant for your organisation. These associated PoF topics will be highlighted on the software evaluation page, making it easier for software maintainers to select a relevant PoF topic when providing reporting information for your organisation.
          <SoftwareEvaluationPoFTopicDropdown
            multiple
            key={'key'}
            tree={pofTopics}
            selectedTopic={organisationCtx.associatedPofTopics}
            setTopic={(topic_ids: string[]) => updateTopics(topic_ids)}
          />
          <Stack direction='row' className='gap-2 flex-wrap'>
            {organisationCtx.associatedPofTopics.map(topic => {
              return <Chip key={topic.id} label={topic.name} onDelete={() => topic.id ? organisationCtx.deletePoFTopicForOrganisation(topic.id) : null} title={String(topic.ancestors?.map(a => a.short_name))}/>
            })}
          </Stack>
        </Stack>
      </DialogContent>
      <DialogActions sx={{padding: 2}}>
        <HgfButton
          style='secondary'
          size='small'
          onClick={onClose}
        >
          Close
        </HgfButton>
      </DialogActions>
    </Dialog>
  )
}
